import i18n from "@app/i18n";
import { selectProfile, setProfile } from "@features/profile/profileSlice";
import accountApi from "@features/share/api/accountApi";
import { DAYS_COOKIES_TRACKING, KEY_AFFILIATE_TRACKING_ID, KEY_TOKEN } from "@features/share/configs/system";
import { logError } from "@features/share/helper/system";
import { originDomain } from "@features/share/hook/helper";
import useGetDomain from "@features/share/hook/useGetDomain";
import { getPassioDomain } from "@features/share/utils/subDomain";
import ThemeBackground from "@shares/ThemeBackground";
import Cookies from 'js-cookie';
import { toNumber } from "lodash";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { useQueries } from "react-query";
import { useDispatch, useSelector } from "react-redux";
const PASSIO_MAIN_DOMAIN = getPassioDomain()

export default function SellerInfo({ children, ...pageProps }: { children: React.ReactNode }) {
  const user = useSelector(selectProfile)
  const dispatch = useDispatch()
  const route = useRouter()
  const { query } = route

  const traffic_id = query.traffic_id?.toString().trim() || '';
  const sub1 = query.sub1?.toString().trim() || '';

  useEffect(() => {
    if (traffic_id || sub1) {
      const dataCookiesTracking = { traffic_id, sub1 };
      Cookies.set(KEY_AFFILIATE_TRACKING_ID, JSON.stringify(dataCookiesTracking), {expires: toNumber(DAYS_COOKIES_TRACKING), domain: originDomain()});
    }
  }, [traffic_id])

  const fetchSiteSetting = () => {
    if(user?.cps_user_id){
      return accountApi.getSiteSetting(user?.cps_user_id)
    }
  }

  const [{data: displaySetting}] = useQueries([
    {
      queryKey: ['loadSideSetting', user?.cps_user_id],
      queryFn: fetchSiteSetting,
      refetchOnWindowFocus: false,
    }
  ])

  const fetchAccount = async () => {
    try {
      const response = await accountApi.getEnduserProfile();

      if (!response) {
        Cookies.remove(KEY_TOKEN, { domain: PASSIO_MAIN_DOMAIN, path: '/' })
        return
      }
    } catch (error) {
      logError(error, 'Locale - fetchAccount')
    }
  }

  const fetchUser = async () => {
    try {
      let locationKey = "en"
      
      const profile = await accountApi.getSellerProfile(useGetDomain())
      const config = await accountApi.getWebsiteConfig(profile?.cps_user_id)

      switch (profile?.country) {
        case 'VN':
          locationKey = "vi"
          break;
        case 'ID':
          locationKey = "id"
          break;
        case 'TH':
          locationKey = "th"
          break;
        default:
          locationKey = "en"
          break
      }
      dispatch(setProfile({...profile, config}))

      i18n.changeLanguage(locationKey).then()
    } catch (error) {
      logError(error, 'Locale - fetchAccount')
    }
  }

  const getAccount = async () => {
    const keyToken = Cookies.get(KEY_TOKEN);
    if (!user && keyToken) {
      fetchAccount().then();
      return
    }
  }

  const getProfile = async () => {
    if (!user) {
      fetchUser().then();
      return
    }
  }

  useEffect(() => {
    getAccount().then();
  }, [user])

  useEffect(() => {
    getProfile().then()
  }, [user])
  
  if (!user) return (<></>)

  return (
    <ThemeBackground displaySetting={displaySetting}>
      {children}
    </ThemeBackground>
  )
}
